import React, { useState, useContext, useEffect } from 'react';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Button from '../Button';
import ForgotPassDialog from './ForgotPassDialog';

import Zoom from '@material-ui/core/Zoom';
import Snackbar from '../Snackbar';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';
import { InputAdornment } from '@material-ui/core';
import UserContext from '../../contexts/UserContext';
import ChangePassForm from './ChangePassForm';

const styles = theme => ({
  root: {
    width: 400,
    minHeight: 250,
    padding: 10,
    display: 'grid',
    gridTemplateColumns: '1fr 4fr 1fr',
    gridTemplateRows: 'repeat(2, 2fr) 50px',
    overflow: 'visible',
  },
  email: {
    gridColumn: 2,
    gridRow: 1,
    placeSelf: 'center',
  },
  password: {
    gridColumn: 2,
    gridRow: 2,
    placeSelf: 'center',
    textAlign: 'end',
  },
  signInButton: {
    gridColumn: 2,
    gridRow: 3,
    placeSelf: 'center',
    width: 150,
    height: 50,
    marginTop: 50,
  },
  forgotButton: {},
  snackbar: {
    backgroundColor: theme.palette.error.dark,
  },
});

const SignInCard = ({ classes }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [willAnimate, setWillAnimate] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showForgotDialog, setShowForgotDialog] = useState(false);
  const [forceChangePass, setForceChangePass] = useState(false);
  const {
    forceChangePass: handleChangePass,
    setError,
    error,
    signIn,
    signingIn: loading,
  } = useContext(UserContext);

  const handleLogin = async e => {
    e.preventDefault();
    const user = await signIn(email, password);
    console.log('SIGN IN CARD USER: ', user);
  };

  useEffect(() => {
    setWillAnimate(true);
  }, []);

  useEffect(() => {
    if (error.hasError) {
      if (error.code === 'NEW_PASSWORD_REQUIRED') {
        setForceChangePass(true);
      }
      console.log('Error on sign in: ', error);
      setHasError(true);
    }
  }, [error.hasError]);

  const handleClose = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setHasError(false);
    setError({ ...error, hasError: false });
  };

  return (
    <>
      <Zoom in={willAnimate} style={{ transitionDelay: willAnimate ? '300ms' : '0ms' }}>
        {forceChangePass ? (
          <ChangePassForm onForceChangePass={handleChangePass} />
        ) : (
          <form data-testid="signInForm" onSubmit={e => handleLogin(e)}>
            <Card raised className={classes.root}>
              <TextField
                fullWidth
                error={hasError}
                inputProps={{ required: true }}
                className={classes.email}
                autoComplete="email"
                variant="outlined"
                label="E-mail"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <div className={classes.password}>
                <TextField
                  error={hasError}
                  variant="outlined"
                  label="Password"
                  type={showPass ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  InputProps={{
                    required: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPass(!showPass)}>
                          {showPass ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  onClick={() => setShowForgotDialog(true)}
                  classes={{ root: classes.forgotButton }}
                  size="small"
                  variant="text"
                >
                  Forgot password?
                </Button>
              </div>
              <Button
                classes={{ root: classes.signInButton }}
                size="large"
                color="secondary"
                disabled={loading}
                type="submit"
              >
                Sign in
              </Button>
            </Card>
          </form>
        )}
      </Zoom>
      <Snackbar
        variant="error"
        open={hasError}
        onClose={handleClose}
        autoHideDuration={5000}
        message={error.message}
      />
      <ForgotPassDialog
        open={showForgotDialog}
        onClose={() => setShowForgotDialog(false)}
      />
    </>
  );
};

export default withStyles(styles)(SignInCard);
